import {
  Directive,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges
} from '@angular/core';

declare let delta: any;

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[credCardType]'
})
export class CreditCardTypeIdentifierDirective implements OnChanges {
  @Input() creditCardNumber: string;
  @Output() creditCardType = new EventEmitter<any>();

  rules = [
    {
      name: 'amex',
      code: 'AX',
      pattern: /^3[47]/,
      valid_length: [15]
    },
    {
      name: 'diners_club_carte_blanche',
      code: 'DC',
      pattern: /^30[0-5]/,
      valid_length: [14]
    },
    {
      name: 'diners_club_international',
      code: 'DC',
      pattern: /^36/,
      valid_length: [14]
    },
    {
      name: 'jcb',
      code: 'JC',
      pattern: /^35(2[89]|[3-8][0-9])/,
      valid_length: [16]
    },
    {
      name: 'laser',
      code: 'LS',
      pattern: /^(6304|670[69]|6771)/,
      valid_length: [16, 17, 18, 19]
    },
    {
      name: 'visa_electron',
      code: 'VI',
      pattern: /^(4026|417500|4508|4844|491(3|7))/,
      valid_length: [16]
    },
    {
      name: 'visa',
      code: 'VI',
      pattern: /^4/,
      valid_length: [16]
    },
    {
      name: 'mastercard',
      code: 'CA',
      pattern: /^5[1-5]/,
      valid_length: [16]
    },
    {
      name: 'maestro',
      code: 'TO',
      pattern: /^(5018|5020|5038|6304|6759|676[1-3])/,
      valid_length: [12, 13, 14, 15, 16, 17, 18, 19]
    },
    {
      name: 'discover',
      code: 'DS',
      pattern:
        /^(6011|622(12[6-9]|1[3-9][0-9]|[2-8][0-9]{2}|9[0-1][0-9]|92[0-5]|64[4-9])|65)/,
      valid_length: [16]
    },
    {
      name: 'uatp',
      code: 'TP',
      pattern: /^1/,
      valid_length: [15, 16]
    }
  ];

  detectCreditCardType(value: string): { [key: string]: any } {
    if (value) {
      const v = value.toString();
      if (!v) {
        this.creditCardType.emit('');
        return null;
      }
      for (const rule of this.rules) {
        if (rule.pattern.test(v)) {
          for (const valid_length of rule.valid_length) {
            if (v.length === valid_length) {
              this.creditCardType.emit(rule.code);
              return null;
            }
          }
        }
      }
      this.creditCardType.emit('');
      return null;
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    this.detectCreditCardType(this.creditCardNumber);
  }
}
